const log = (str) => {
    console.log('[log]',str);
}

export default log